export default __webpack_public_path__ + "static/media/login-logo.ce501e25.png";